export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--stop.51ae50fd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};